import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import axios from "../apis/axios";
import useRequests from "./useRequests";
import { toast } from 'react-toastify';

const LOGIN_URL = '/api/login';
const SIGN_URL = '/api/register';

export const useAuth = () => {
    const [user, setUser] = useLocalStorage("user", null);
    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [successMsg, setSuccessMsg] = useState(null)

    const http = useRequests();
    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.from?.pathname || "/db/dashboard";

    const login = async (data) => {
        setLoading(true)
        setErrorMessage(null)
        try {
            const res = await axios.post(LOGIN_URL, data);
            console.log(res);
            if (res.data){
                setUser(res.data);
                    navigate(from, { replace: true });
                }
                
            setLoading(false)
        } catch (err) {
            console.log(err);
            if (err.response.data) {
                setErrorMessage(err.response.data.message)
            }
            setLoading(false)
        }

    }

    const signUp = async (data,reset) => {
        setLoading(true);
        setErrorMessage(null)
        try {
            const res = await axios.post(SIGN_URL, data);
            console.log(res);
            if(res.data.success){
                setSuccessMsg(res.data.message)
                toast.success("The account created successfully!")
                reset({})
            }
         
         
            setLoading(false)
   
        } catch (err) {
            console.log(err);
            if (err.response.data) {
                setErrorMessage(err.response.data.message)
            }
            setLoading(false)
        }
    }

    const logout =  async() => {
      
        await http.post('api/logout').then(res => console.log(res));
        setUser(null);
        setErrorMessage(null)
       
        navigate("/db/login", { replace: true });
    };

    const isCreator = (id)=>{
          return  id === user?.user?.id
    }
    

    const getUserID = ()=>{
          return  user?.user?.id
    }
    const hasRole = (roles) => {
        return roles?user?.user?.roles?.some((r) =>roles?.some(f=> f===r.value)) || 
        (roles?.some(f=> f===0) && user?.user?.roles?.some((r) =>r.value!==4)):false;
      }
    

 const value = {
        user,
        login,
        logout,
        errorMessage,
        setErrorMessage,
        loading,
        signUp,
        setUser,
        successMsg,
        getUserID,
        isCreator,
        hasRole,
    } 
    return value;

   
};

export default useAuth;

